import from0to1 from './from0to1';

export const CURRENT_EDITABLE_VERSION = 1;
export default [from0to1];
